import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { businessTypes } from '../config'

export const getBusinessTypeCrud = () => {
  return new Crud({
    fetcher: new Static(businessTypes.map((el) => ({ key: el, label: el }))),
    keyField: 'key',
  })
}
